// Shortcuts that open developer tools or the page source; matched on code, since Option changes key on a Mac.
const DEVTOOLS_SHORTCUTS = [
  (event) => event.code === "F12",
  (event) => event.ctrlKey && event.shiftKey && ["KeyI", "KeyJ", "KeyC"].includes(event.code),
  (event) => event.ctrlKey && !event.shiftKey && !event.altKey && event.code === "KeyU",
  (event) => event.metaKey && event.altKey && ["KeyI", "KeyJ", "KeyC", "KeyU"].includes(event.code),
  (event) => event.metaKey && event.shiftKey && event.code === "KeyC"
]

function isEditable(target) {
  return target instanceof Element && Boolean(target.closest("input, textarea, [contenteditable='true']"))
}

// Hides the browser's context menu, long-press image actions, text selection and developer-tools shortcuts.
export function lockBrowserControls() {
  document.documentElement.dataset.browserControls = "locked"

  document.addEventListener(
    "contextmenu",
    (event) => {
      if (!isEditable(event.target)) event.preventDefault()
    },
    { capture: true }
  )

  window.addEventListener(
    "keydown",
    (event) => {
      if (DEVTOOLS_SHORTCUTS.some((matches) => matches(event))) event.preventDefault()
    },
    { capture: true }
  )
}
